import { checkPassword } from '../../api';
import createAsyncValidator from '../../core/createAsyncValidator';

const passwordAsyncValidation = (email) =>
  createAsyncValidator((value) => checkPassword({ email, password: value }));

export default passwordAsyncValidation;
